import { createFileRoute } from "@tanstack/react-router"
import { Diff } from "@/components/diff/diff"

export const Route = createFileRoute("/diff")({
	component: Diff,
	validateSearch: (search: Record<string, unknown>): { game?: string } =>
		typeof search.game === "string" ? { game: search.game } : {},
})
